import { FileText, PlusSquare, UserPlus, Users } from "lucide-react";
import {
  DashboardQuickAccess,
  type DashboardQuickAccessConfig,
} from "../dashboard/DashboardQuickAccess";

type QuickAccessItem = {
  id: "admissions" | "invoices" | "agents" | "beneficiaries";
  href: string;
  label: string;
};

type EnterpriseDashboardQuickAccessProps = {
  items: QuickAccessItem[];
  activeId: string;
  onSelect: (id: string) => void;
};

const quickAccessConfig: Record<QuickAccessItem["id"], DashboardQuickAccessConfig> = {
  admissions: { icon: PlusSquare, tone: "green" },
  invoices: { icon: FileText, tone: "blue" },
  agents: { icon: UserPlus, tone: "orange" },
  beneficiaries: { icon: Users, tone: "purple" },
};

export function EnterpriseDashboardQuickAccess({
  items,
  activeId,
  onSelect,
}: EnterpriseDashboardQuickAccessProps) {
  return (
    <DashboardQuickAccess
      items={items}
      configById={quickAccessConfig}
      activeId={activeId}
      onSelect={onSelect}
    />
  );
}
